'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var lodash = require('lodash');
var reactRedux = require('react-redux');
var classNames = require('classnames');
var text$1 = require('@piconetworks/text');
var produce = require('immer');
var effects = require('redux-saga/effects');
var axios = require('axios');
var Marked = require('marked');
var DOMPurify = require('dompurify');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var produce__default = /*#__PURE__*/_interopDefaultLegacy(produce);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
var Marked__default = /*#__PURE__*/_interopDefaultLegacy(Marked);
var DOMPurify__default = /*#__PURE__*/_interopDefaultLegacy(DOMPurify);

var selectors = {
  isFetchingMarkdown: function isFetchingMarkdown() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingMarkdown;
  },
  markdownFiles: function markdownFiles() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref2.text;

    return text === null || text === void 0 ? void 0 : text.markdownFiles;
  },
  isFetchingJson: function isFetchingJson() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref3.text;

    return text === null || text === void 0 ? void 0 : text.isFetchingJson;
  },
  jsonFiles: function jsonFiles() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        text = _ref4.text;

    return text === null || text === void 0 ? void 0 : text.jsonFiles;
  },
  getMarkdownFile: function getMarkdownFile(state, url) {
    var markdownFiles = selectors.markdownFiles(state);
    return markdownFiles[url];
  },
  getJsonFile: function getJsonFile(state, url) {
    var jsonFiles = selectors.jsonFiles(state);
    return jsonFiles[url];
  }
};

var actionCreatorFactory = function actionCreatorFactory(type) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        payload = _ref.payload,
        error = _ref.error;

    return Object.assign({
      type: type
    }, payload && {
      payload: payload
    }, error && {
      error: error
    });
  };
};

var types = {
  FETCH_MARKDOWN: 'FETCH_MARKDOWN',
  FETCH_MARKDOWN_SUCCESS: 'FETCH_MARKDOWN_SUCCESS',
  FETCH_MARKDOWN_ERROR: 'FETCH_MARKDOWN_ERROR',
  FETCH_JSON: 'FETCH_JSON',
  FETCH_JSON_SUCCESS: 'FETCH_JSON_SUCCESS',
  FETCH_JSON_ERROR: 'FETCH_JSON_ERROR'
};
var creators = {
  fetchMarkdown: actionCreatorFactory(types.FETCH_MARKDOWN),
  fetchMarkdownSuccess: actionCreatorFactory(types.FETCH_MARKDOWN_SUCCESS),
  fetchMarkdownError: actionCreatorFactory(types.FETCH_MARKDOWN_ERROR),
  fetchJson: actionCreatorFactory(types.FETCH_JSON),
  fetchJsonSuccess: actionCreatorFactory(types.FETCH_JSON_SUCCESS),
  fetchJsonError: actionCreatorFactory(types.FETCH_JSON_ERROR)
};

var styles = {"reset":"RemoteMarkdown-module_reset__35Tfi","h1":"RemoteMarkdown-module_h1__23poZ","h2":"RemoteMarkdown-module_h2__3xASM","h3":"RemoteMarkdown-module_h3__2VJ4M","h4":"RemoteMarkdown-module_h4__28Fsm","h5":"RemoteMarkdown-module_h5__3GG7I","h6":"RemoteMarkdown-module_h6__ZYpGV","clearfix":"RemoteMarkdown-module_clearfix__3kXp3","lastcol":"RemoteMarkdown-module_lastcol__2p6Sr","ffluid":"RemoteMarkdown-module_ffluid__20HAL","cb":"RemoteMarkdown-module_cb__qo1p-","fcolholder":"RemoteMarkdown-module_fcolholder__DGyBP","col":"RemoteMarkdown-module_col__3q-31","col-1_1":"RemoteMarkdown-module_col-1_1__31bfJ","col-1_2":"RemoteMarkdown-module_col-1_2__f9a3b","col-2_4":"RemoteMarkdown-module_col-2_4__17Mvk","col-3_6":"RemoteMarkdown-module_col-3_6__1kxwu","col-1_3":"RemoteMarkdown-module_col-1_3__2oaH7","col-2_6":"RemoteMarkdown-module_col-2_6__1jgXZ","col-2_3":"RemoteMarkdown-module_col-2_3__2ZH3W","col-4_6":"RemoteMarkdown-module_col-4_6__3frhZ","col-1_4":"RemoteMarkdown-module_col-1_4__2ltr-","col-3_4":"RemoteMarkdown-module_col-3_4__3s4fJ","col-1_5":"RemoteMarkdown-module_col-1_5__9TSyk","col-2_5":"RemoteMarkdown-module_col-2_5__Rf4DC","col-3_5":"RemoteMarkdown-module_col-3_5__1WfHw","col-4_5":"RemoteMarkdown-module_col-4_5__2qhgU","col-1_6":"RemoteMarkdown-module_col-1_6__16cC5","col-5_6":"RemoteMarkdown-module_col-5_6__3oUWp","ir":"RemoteMarkdown-module_ir__343bZ","fl":"RemoteMarkdown-module_fl__31agE","fr":"RemoteMarkdown-module_fr__2RY-G","cr":"RemoteMarkdown-module_cr__gFi8a","cl":"RemoteMarkdown-module_cl__LEb8N","hidden":"RemoteMarkdown-module_hidden__4JPgZ","invisible":"RemoteMarkdown-module_invisible__1OkcD","vcenter":"RemoteMarkdown-module_vcenter__3WcZi","outer":"RemoteMarkdown-module_outer__1TORS","inner":"RemoteMarkdown-module_inner__3MRAn","hcenter":"RemoteMarkdown-module_hcenter__3KrHO","tcenter":"RemoteMarkdown-module_tcenter__1rvfG","tleft":"RemoteMarkdown-module_tleft__9rS-R","tright":"RemoteMarkdown-module_tright__2u6Z9","tupper":"RemoteMarkdown-module_tupper__3Swkd","tlower":"RemoteMarkdown-module_tlower__3UK1o","tnormal":"RemoteMarkdown-module_tnormal__3hoka","ttop":"RemoteMarkdown-module_ttop__3tipN","tmiddle":"RemoteMarkdown-module_tmiddle__1dmv2","tbottom":"RemoteMarkdown-module_tbottom__17eC3","clickable":"RemoteMarkdown-module_clickable__vcKTP","btn":"RemoteMarkdown-module_btn__20ryN","disabled":"RemoteMarkdown-module_disabled__uy9Re","b":"RemoteMarkdown-module_b__2JHz2","em":"RemoteMarkdown-module_em__9GoXB","big":"RemoteMarkdown-module_big__1vkrp","small":"RemoteMarkdown-module_small__28Q51","del":"RemoteMarkdown-module_del__1nLY1","nav":"RemoteMarkdown-module_nav__2N942","hlnav":"RemoteMarkdown-module_hlnav__ddA9N","hrnav":"RemoteMarkdown-module_hrnav__eDWoX","simpleList":"RemoteMarkdown-module_simpleList__1QYGF","gridholder":"RemoteMarkdown-module_gridholder__3cDr1","grid":"RemoteMarkdown-module_grid__DY2St","grid-1":"RemoteMarkdown-module_grid-1__3vkUF","grid-2":"RemoteMarkdown-module_grid-2__pfhMz","grid-3":"RemoteMarkdown-module_grid-3__2Pkny","grid-4":"RemoteMarkdown-module_grid-4__28dGg","grid-5":"RemoteMarkdown-module_grid-5__1aqh1","grid-6":"RemoteMarkdown-module_grid-6__1_Hz0","grid-7":"RemoteMarkdown-module_grid-7__1OqF_","grid-8":"RemoteMarkdown-module_grid-8__WCYnG","grid-9":"RemoteMarkdown-module_grid-9__1_0_5","grid-10":"RemoteMarkdown-module_grid-10__a4pAm","grid-11":"RemoteMarkdown-module_grid-11__22kLx","grid-12":"RemoteMarkdown-module_grid-12__3Lgzg","fgridholder":"RemoteMarkdown-module_fgridholder__2YdIr","fgrid-1":"RemoteMarkdown-module_fgrid-1__18LaQ","fgrid-2":"RemoteMarkdown-module_fgrid-2__3yuw8","fgrid-3":"RemoteMarkdown-module_fgrid-3__19dS2","fgrid-4":"RemoteMarkdown-module_fgrid-4__1GFHH","fgrid-5":"RemoteMarkdown-module_fgrid-5__3quaO","fgrid-6":"RemoteMarkdown-module_fgrid-6__3BawQ","fgrid-7":"RemoteMarkdown-module_fgrid-7__2gcSr","fgrid-8":"RemoteMarkdown-module_fgrid-8__2B2wK","fgrid-9":"RemoteMarkdown-module_fgrid-9__1H5Nk","fgrid-10":"RemoteMarkdown-module_fgrid-10__3IVEm","fgrid-11":"RemoteMarkdown-module_fgrid-11__3ReoP","fgrid-12":"RemoteMarkdown-module_fgrid-12__1xaA2","wrapper":"RemoteMarkdown-module_wrapper__27QbS"};

/* eslint-disable react/no-danger */

var RemoteMarkdown = function RemoteMarkdown(_ref) {
  var url = _ref.url,
      options = _ref.options,
      onClickLink = _ref.onClickLink;
  var dispatch = reactRedux.useDispatch();
  var markdownFile = reactRedux.useSelector(function (state) {
    return selectors.getMarkdownFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingMarkdown(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (url && !markdownFile && !(markdownFile !== null && markdownFile !== void 0 && markdownFile.error) && !isFetching) {
      dispatch(creators.fetchMarkdown({
        payload: {
          url: url,
          options: options
        }
      }));
    }
  }, [dispatch, url, options, isFetching]);

  if (!markdownFile || markdownFile.error || !markdownFile.html) {
    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: styles.reset,
    dangerouslySetInnerHTML: {
      __html: markdownFile.html
    },
    onClick: function onClick(event) {
      var _event$target;

      event.stopPropagation();
      event.preventDefault();
      var href = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.href;
      onClickLink(href);
    }
  });
};

RemoteMarkdown.defaultProps = {
  onClickLink: function onClickLink() {},
  options: {}
};
RemoteMarkdown.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  onClickLink: PropTypes__default['default'].func,
  options: PropTypes__default['default'].object
};

/* eslint-disable react/no-danger */

var RemoteJsonText = function RemoteJsonText(_ref) {
  var url = _ref.url,
      linkColor = _ref.linkColor,
      style = _ref.style;
  var dispatch = reactRedux.useDispatch();
  var json = reactRedux.useSelector(function (state) {
    return selectors.getJsonFile(state, url);
  }, lodash.isEqual);
  var isFetching = reactRedux.useSelector(function (state) {
    return selectors.isFetchingJson(state, url);
  }, lodash.isEqual);
  React.useEffect(function () {
    if (!isFetching && url && !json && !(json !== null && json !== void 0 && json.error)) {
      dispatch(creators.fetchJson({
        payload: {
          url: url
        }
      }));
    }
  }, [isFetching, JSON.stringify(json)]);

  if (!json || json !== null && json !== void 0 && json.error) {
    return null;
  }

  var _ref2 = json || {},
      _ref2$description = _ref2.description,
      description = _ref2$description === void 0 ? '' : _ref2$description,
      _ref2$feature_list = _ref2.feature_list,
      featureList = _ref2$feature_list === void 0 ? [] : _ref2$feature_list;

  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, description && /*#__PURE__*/React__default['default'].createElement(text$1.P, null, description), /*#__PURE__*/React__default['default'].createElement("ul", {
    className: style.list
  }, featureList.map(function (item, i) {
    return /*#__PURE__*/React__default['default'].createElement("li", {
      key: i
    }, /*#__PURE__*/React__default['default'].createElement("i", {
      className: classNames__default['default'](style.icon, 'icon-icon_checkmark'),
      style: {
        color: linkColor
      }
    }), item.label, item.detail && /*#__PURE__*/React__default['default'].createElement("span", null, item.detail));
  })));
};

RemoteJsonText.defaultProps = {// options: {},
};
RemoteJsonText.propTypes = {
  url: PropTypes__default['default'].string.isRequired,
  linkColor: PropTypes__default['default'].any.isRequired,
  style: PropTypes__default['default'].any.isRequired
};
var RemoteJsonText$1 = React__default['default'].memo(RemoteJsonText);

var initialState = {
  isFetchingMarkdown: null,
  markdownFiles: {},
  isFetchingJson: null,
  jsonFiles: {}
};

var reducer = function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type,
      payload = _ref.payload,
      error = _ref.error;

  return produce__default['default'](state, function (draftState) {
    switch (type) {
      case types.FETCH_MARKDOWN:
        draftState.isFetchingMarkdown = true;
        break;

      case types.FETCH_MARKDOWN_SUCCESS:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = payload;
        break;

      case types.FETCH_MARKDOWN_ERROR:
        draftState.isFetchingMarkdown = false;
        draftState.markdownFiles[payload.url] = {
          error: error
        };
        break;

      case types.FETCH_JSON:
        draftState.isFetchingJson = true;
        break;

      case types.FETCH_JSON_SUCCESS:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = payload.json;
        break;

      case types.FETCH_JSON_ERROR:
        draftState.isFetchingJson = false;
        draftState.jsonFiles[payload.url] = {
          error: error
        };
        break;

    }

    return undefined;
  });
};

var marked = function marked(markdownString, options) {
  return new Promise(function (resolve, reject) {
    return Marked__default['default'](markdownString, options, function (err, html) {
      if (err) {
        return reject(err);
      }

      return resolve(html);
    });
  });
};

function* fetchMarkdown(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;
  var options = (payload === null || payload === void 0 ? void 0 : payload.options) || {};

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var html = yield effects.call(marked, response.data, options);
    var cleanHtml = DOMPurify__default['default'].sanitize(html);
    yield effects.put(yield effects.call(creators.fetchMarkdownSuccess, {
      payload: {
        url: url,
        html: cleanHtml
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchMarkdownError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

function* fetchJson(_ref) {
  var payload = _ref.payload;
  var url = payload === null || payload === void 0 ? void 0 : payload.url;

  try {
    if (!url) {
      throw new Error('markdown url must be provided');
    }

    var response = yield effects.call(axios__default['default'], {
      method: 'get',
      timeout: 5000,
      url: url
    });

    if (!response || !response.data) {
      throw new Error('response object not returned from axios');
    }

    var json = response.data;
    yield effects.put(yield effects.call(creators.fetchJsonSuccess, {
      payload: {
        url: url,
        json: json
      }
    }));
  } catch (error) {
    yield effects.put(yield effects.call(creators.fetchJsonError, {
      payload: {
        url: typeof url === 'undefined' ? null : url
      },
      error: error.message
    }));
  }
}

var takes = [effects.takeEvery(types.FETCH_MARKDOWN, fetchMarkdown), effects.takeEvery(types.FETCH_JSON, fetchJson)];
var sagas = {
  fetchMarkdown: fetchMarkdown,
  fetchJson: fetchJson
};

var text = {
  store: 'text',
  initialState: initialState,
  reducer: reducer,
  types: types,
  creators: creators,
  sagas: sagas,
  takes: takes,
  selectors: selectors
};

exports.RemoteJsonText = RemoteJsonText$1;
exports.RemoteMarkdown = RemoteMarkdown;
exports.text = text;
